import React from 'react';
import { useSelector } from "react-redux";
import DataguardHeatmap from '../DataguardHeatmap';
import SmallHeatmap from '../SmallHeatmap';
import FullscreenIcon from "@material-ui/icons/Fullscreen";

const PublicDataCard = ({ showExpandedView, isPopup=false, onClick }) => {
  const dataguardHeaderData = useSelector((state) => state.DataguardReducer.dataguardHeaderData);
  const publicAccess = dataguardHeaderData?.publicAccess;
  const totalAssetsCount = useSelector((state) => state.DataguardReducer.totalAssetsCount);

  // Format numbers with US commas
  const formattedTotalAssetsCount = parseInt(totalAssetsCount || '0').toLocaleString('en-US');
  const formattedPublicAssetsCount = parseInt(publicAccess?.alertCount || '0').toLocaleString('en-US');

  return (
    <div className="column-card public-data-card">
      <div className='details-container' onClick={onClick}>
        <div className='left-details'>
          <div className='left-details-container'>
            <div className='icon-container'>
              <img src='/dashboardIcons/publicActive.svg' alt='Location Icon' />
              <span className='ico-label'>Public Data Assets</span>
            </div>
            <div className='left-details-txt'>
              <span>Total # of Assets</span>
              <span className='no-locs'>{formattedTotalAssetsCount || 0}</span>
            </div>
            <div className='left-details-txt'>
              <span>Total # of Public Assets</span>
              <span className='loc-alert'>{formattedPublicAssetsCount || 0}</span>
            </div>
            {isPopup && <div className='small-heatmap-popup'><SmallHeatmap /></div>}
          </div>
        </div>
        <div className='right-chart'>
          <DataguardHeatmap loc={isPopup ? 'dashboardPopup' : 'default'} />
        </div>
      </div>
      {!isPopup && <div className='small-heatmap-card'><SmallHeatmap /></div>}
      {!isPopup ? (
        <div className='fullscreen-icon public-data' onClick={(e) => {showExpandedView('heatmap');e.stopPropagation();}}>
          <FullscreenIcon fontSize="small"/>
        </div>
      ) : (
        null
      )}
    </div>
  );
};

export default PublicDataCard;